import cn from "classnames";
import PropTypes from "prop-types";
import { Stack } from "react-bootstrap";
import Button from "components/Button";

const Buttons = ({ className = "flex-row", buttons = [] }) => {
  if (buttons?.length > 0)
    return (
      <Stack className={cn(className)}>
        {buttons.map((button, index) => {
          return (
            <Button
              key={index}
              text={button?.text}
              url={button?.url}
              button_new_tab={
                button?.url.startsWith("http") ? "_blank" : "_self"
              }
              className={button?.className}
              showArrow={button?.showArrow}
              buttonDom={button?.buttonDom}
            />
          );
        })}
      </Stack>
    );
  return;
};

Buttons.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.object),
};

export default Buttons;